<template>
  <DisplaySection class="section" :padding="false">
    <LbViewRouter v-if="!error" />
  </DisplaySection>
</template>
<script setup lang="ts">
import { LibraryTypes } from '~/types/adamTypes';
interface Props {
  field: FormField;
}
defineProps({
  field: null
});
const model = defineModel<any>();
const {
  submit,
  previous: previousStep,
  hasPrevious: hasPreviousFormStep,
} = inject(INJECT_FORM_PAGE);

const { formNavigation } = inject(INJECT_FORM_PAGE);

const {
  onSubmit,
  onPrevious,
  switchToLocalSubmitButtons,
  setDefaultSubmitButtons,
} = formNavigation;
const { t } = useI18n();
const error = ref();
const libraryForm = useLibraryPageOrForm(
  'form',
  LibraryTypes.FreeLibraryRootBox
);
const { libraryManager, libraryViewRouter, libraryStrategy } = libraryForm;
const { library, libraryBook } = libraryManager;
const { hasPrevious } = libraryStrategy;
provide(INJECT_LIBRARY_PAGE_OR_FORM, libraryForm);
try {
  await libraryForm.libraryManager.load(
    libraryForm.libraryStrategy.slugs.value,
    2
  );
} catch (e) {
  error.value = e;
}

onSubmit((id) => {
  model.value = id;
  submit();
});

onPrevious(() => {
  if (hasPrevious.value) {
    libraryStrategy.goBack();
  } else if (hasPreviousFormStep) {
    previousStep();
  }
});

const selectable = computed(() => {
  return !(
    library.value &&
    !['ViewLibraryDefaultLb', 'ViewLibraryDefaultShelf'].includes(
      libraryViewRouter.view.value.__name
    )
  );
});

const children = computed(() => {
  if (!selectable.value) return [];
  return libraryBook.value ? [libraryBook.value] : library.value.children;
});

const hasButtonPrevious = computed(() => {
  return hasPreviousFormStep.value || hasPrevious.value;
});

watch(
  () => children.value.length > 0,
  (hasChildren) => {
    if (hasChildren) {
      const length = children.value.length;
      const buttons = children.value.map((child) => {
        const label =
          length === 1
            ? t('library.form.button.select')
            : t('library.form.button.select', { label: child.metaSubtitle });
        return { id: child.id, label };
      });
      formNavigation.lock(1);
      switchToLocalSubmitButtons(buttons);
    } else {
      formNavigation.lock(2);
      setDefaultSubmitButtons();
    }
  }
);

onMounted(() => {
  formNavigation.lock(2);
});

onUnmounted(() => {
  formNavigation.lock(0);
});
</script>
<style lang="scss" scoped>
section.section {
  padding: 0;
}
</style>
